import gsap from 'gsap';

const open = gsap.timeline({
    paused: true,
});

open
    .to('.collapse', 0.3, {
        autoAlpha: 1,
        opacity: 1,
        ease: "easeInOut",
        display:"block",
    })
    .to('html, body', {
        overflow: 'hidden',
    }, '<')
    .staggerTo('.header-menu, .collapse__close', 0.05, {
        x: "0",
        autoAlpha: 1,
        opacity: 1,
        ease: "easeInOut",
    },0.2, '<')
    .to('.collapse__wrapper', 0.4, {
        x: "0",
        ease: "easeInOut",
    }, '<')
    .to('.collapse__wrapper', 0.2, {
        clipPath: 'polygon(0% 100%, 100% 100%, 100% 0, 0% 0, 0 0%)',
        ease: "easeInOut",
    },0.2, '<')

const close = gsap.timeline({
    paused: true,
    defaults: { clearProps: true },
});

close
    .staggerTo('.header-menu, .collapse__close', 0.05, {
        opacity: 0,
        ease: "easeInOut",
    })
    .to('.collapse__wrapper', 0.3, {
        x: "100%",
        clipPath: 'polygon(37vh 100%, 100% 100%, 100% 0, 28vh 0, 0 28vh)',
        ease: "easeInOut",
    }, '<')
    .to('.collapse', 0.3, {
        x: 0,
        opacity: 0,
        ease: "easeInOut",
        display:"none",
    }, '<')
    .to('html, body', {
        overflow: '',
    })

const open_mobile = gsap.timeline({
    paused: true,
});
    
open_mobile
    .to('.collapse', 0, {
        autoAlpha: 1,
        opacity: 1,
        ease: "easeInOut",
        display:"block",
    })
    .staggerTo('.header-menu, .collapse__close', 0, {
        // y: "0",
        autoAlpha: 1,
        // opacity: 1,
        ease: "easeInOut",
    })
    .to('html, body', {
        overflow: 'hidden',
    })

const close_mobile = gsap.timeline({
    paused: true,
    defaults: { clearProps: true },
});

close_mobile
    .to('.collapse__close', 0, {
        opacity:0,
    })
    .to('html, body', {
        overflow: '',
    })
    .to('.collapse', 0.5, {
        autoAlpha: 0,
        opacity: 0,
        ease: "easeInOut",
        display:"none",
    }, '<')

const timelineToggle = (timeline) => {
    if( timeline.progress() < 1 ) {
        timeline.play();
    } else {
        timeline.restart();
    }
}

const removeItems = () => {

}

$(document).on('click', '.header__content__actions__toggle, .collapse__close', function () {
    if(window.innerWidth <= 992) {
        if( !$(this).hasClass('collapsed')) {
            removeItems();
            timelineToggle(close_mobile);
        } else {
           timelineToggle(open_mobile);
        }
    }else{
        if( !$(this).hasClass('collapsed')) {
            removeItems();
            timelineToggle(close);
        } else {
            timelineToggle(open);
        }
    }
});

$(document).on('keydown', function(event) {
    if (event.keyCode === 27 || event.key === 'Escape') {
        var style = $('.collapse__wrapper').css('clip-path');
        if(style == 'polygon(0% 100%, 100% 100%, 100% 0px, 0% 0px, 0px 0%)') {
            removeItems();
            timelineToggle(close);
        }
    }
});

$(window).on('resize', function() {
    if($('.collapse').is(":visible")){
        removeItems();
        timelineToggle(close);
    }
});
